import type { ReactNode } from 'react';
import { clsx } from 'clsx';
import { Skeleton } from '@interxfi/design-system/components/loading/skeleton';
import { ImageLoadingStatus, useImageLoader } from '@interxfi/design-system/util/image';
import styles from './asset-logo.module.scss';

export type AssetLogoSize = 'x-small' | 'small' | 'medium';

interface AssetLogoProps {
  alt: string | undefined;
  className?: string;
  placeholder?: ReactNode;
  placeholderBorder?: boolean;
  src?: string;
  size?: AssetLogoSize;
}

export function AssetLogo({ alt, className, placeholder, placeholderBorder = true, src, size = 'medium' }: AssetLogoProps) {
  const imageStatus = useImageLoader(src);
  const sizeClassName = size !== 'medium' ? styles[`size-${size}`] : undefined;

  if (src && imageStatus === ImageLoadingStatus.Loading) {
    return <Skeleton parentClassName={clsx(styles.assetLogoContainer, styles.assetLogo, sizeClassName, className)} type="rect" />;
  }

  if (src && imageStatus !== ImageLoadingStatus.Error) {
    return <img alt={alt} className={clsx(styles.assetLogoContainer, styles.assetLogo, sizeClassName, className)} src={src} />;
  }

  return (
    <div className={clsx(styles.assetLogoContainer, styles.placeholder, placeholderBorder && styles.withBorder, sizeClassName, className)}>
      {placeholder}
    </div>
  );
}
